import { CommonModule } from '@angular/common';
import { Component, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalDialogRef } from '@shared/modal-dialog/modal-dialog-ref';
import { MODAL_DIALOG_DATA } from '@shared/modal-dialog/modal-dialog.tokens';
import { SharedModule } from '@shared/shared.module';

interface StatsigFlag {
	name: string;
	value: unknown;
}

interface StatsigFlagsDialogData {
	flags: StatsigFlag[];
	stableId?: string;
	userId?: string;
}

@Component({
	selector: 'qe-statsig-flags-dialog',
	standalone: true,
	imports: [CommonModule, SharedModule],
	templateUrl: './statsig-flags-dialog.component.html',
	styleUrls: ['./statsig-flags-dialog.component.scss'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StatsigFlagsDialogComponent {
	public flags: StatsigFlag[] = [];
	public stableId = '';
	public userId = '';
	public copied = false;
	public userIdCopied = false;

	constructor(
		@Inject(MODAL_DIALOG_DATA) data: StatsigFlagsDialogData | StatsigFlag[] | undefined,
		private readonly dialogRef: ModalDialogRef<void>
	) {
		this.flags = Array.isArray(data) ? data : data?.flags || [];
		this.stableId = Array.isArray(data) ? '' : data?.stableId || '';
		this.userId = Array.isArray(data) ? '' : data?.userId || '';
	}

	public async copyStableId(): Promise<void> {
		if (!this.stableId) {
			return;
		}

		await navigator.clipboard.writeText(this.stableId);
		this.copied = true;
	}

	public async copyUserId(): Promise<void> {
		if (!this.userId) {
			return;
		}

		await navigator.clipboard.writeText(this.userId);
		this.userIdCopied = true;
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
}
